import { Box } from '@mui/material';
import React from 'react';

/** Responsive reading width inside the persistent student application shell. */
export default function VerbaScholaStudentPageContent({ children, maxWidth = 1180 }: { children: React.ReactNode; maxWidth?: number }) {
    return <Box sx={{ width: '100%', maxWidth: { xs: 430, sm: maxWidth }, mx: 'auto', px: { xs: 2.5, sm: 3, lg: 4 }, pt: { xs: 3, md: 4 }, pb: 6 }}>{children}</Box>;
}
